import React from "react";
import { FieldArray, useFormikContext } from "formik";
import Select from "./FormikSelectField";
import { IoCloseCircle } from "react-icons/io5";
import { useGetRoles } from "../hooks/roles/useGet";

const RoleFormArray = () => {
  const { values } = useFormikContext();
  const { data: roles, isSuccess: gotRoles } = useGetRoles();

  const roleOptions = roles?.map((item) => ({
    value: item.roleId,
    name: item.roleName,
  }));
  return (
    <FieldArray name="roleForms">
      {({ insert, remove, push }) => (
        <div>
          <button
            type="button"
            className="border border-slate-600 text-sm px-2 py-1.5 mb-2 w-full mt-2"
            onClick={() =>
              push({
                roleId: 0,
              })
            }
          >
            Add Roles to view
          </button>

          {values.roleForms.length > 0 &&
            values.roleForms.map((note, index) => (
              <div className="flex w-full flex-col border border-gray-300 rounded p-3 mb-3 bg-stone-50" key={index}>
                <IoCloseCircle
                  onClick={() => remove(index)}
                  className="text-red-600 text-2xl self-end  cursor-pointer transition-all ease-in-out hover:scale-110"
                />
                {gotRoles && (
                  <Select
                    name={`roleForms.${index}.roleId`}
                    id={`roleForms.${index}.roleId`}
                    label="Select Role"
                    defaultValue={
                      values.roleForms[index]
                    }
                    required
                    options={roleOptions}
                  />
                )}
              </div>
            ))}
        </div>
      )}
    </FieldArray>
  );
};

export default RoleFormArray;
